import { z } from 'zod';

/**
 * Mensagens padrão do Zod em português (as que o schema não personaliza). Vale para a API, o
 * painel e a loja, que importam os contratos.
 */
z.config(z.locales.ptBR());
